import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import styled from 'styled-components';

const Bar = styled.header`
  position: sticky;
  top: 0;
  z-index: 100;
  background: ${p => p.scrolled ? 'rgba(243, 236, 223, 0.9)' : 'transparent'};
  backdrop-filter: ${p => p.scrolled ? 'blur(8px)' : 'none'};
  border-bottom: 1px solid ${p => p.scrolled ? 'var(--rule)' : 'transparent'};
  transition: background .2s ease, border-color .2s ease;
`;

const Inner = styled.nav`
  max-width: var(--max-width);
  margin: 0 auto;
  padding: 16px 28px;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 24px;

  @media (max-width: 600px) { padding: 14px 22px; }
`;

const Name = styled.a`
  font-family: 'EB Garamond', Georgia, serif;
  font-size: 1.15rem;
  font-weight: 500;
  color: var(--ink);
  cursor: pointer;
  text-decoration: none;
  letter-spacing: 0.005em;

  em { font-style: italic; color: var(--ink-muted); font-weight: 400; }

  &:hover { text-decoration: none; color: var(--accent); }
`;

const Links = styled.div`
  display: flex;
  gap: 22px;
  align-items: baseline;

  @media (max-width: 600px) { gap: 16px; }
`;

const NavLink = styled(Link)`
  font-family: 'EB Garamond', Georgia, serif;
  font-style: italic;
  font-size: 1rem;
  color: var(--ink-soft);
  cursor: pointer;
  text-decoration: none;
  transition: color .15s;
  padding: 8px 0;

  &:hover { color: var(--accent); text-decoration: none; }

  @media (max-width: 600px) {
    &.hide-mobile { display: none; }
  }
`;

function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <Bar scrolled={scrolled}>
      <Inner>
        <Name href="#" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
          Ali Hamza
        </Name>
        <Links>
          <NavLink to="projects" smooth duration={350}>projects</NavLink>
          <NavLink to="work" smooth duration={350}>experience</NavLink>
          <NavLink to="about" smooth duration={350} className="hide-mobile">about</NavLink>
          <NavLink to="contact" smooth duration={350}>contact</NavLink>
        </Links>
      </Inner>
    </Bar>
  );
}

export default Header;
